
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {OrderCloseAllResponse} from './OrderCloseAllResponse';

/**
 * OrderCloseAllByIdRequest struct
 */
class OrderCloseAllByIdRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!Array=} orderIds
   * @constructor
   */
  constructor (parent = new Request(), orderIds = []) {
    super()
    super.copy(parent)
    this.OrderIds = orderIds
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrderCloseAllByIdRequest}
   * @param {!OrderCloseAllByIdRequest} other Other struct
   * @returns {!OrderCloseAllByIdRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.OrderIds != null) {
      this.OrderIds = []
      for (let item of other.OrderIds) {
        if (item != null) {
          let tempItem
          tempItem = UInt64.fromNumber(item)
          this.OrderIds.push(tempItem)
        } else {
          this.OrderIds.push(null)
        }
      }
    } else {
      this.OrderIds = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrderCloseAllByIdRequest}
   * @returns {!OrderCloseAllByIdRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrderCloseAllByIdRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrderCloseAllByIdRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrderCloseAllByIdRequest}
   * @param {!OrderCloseAllByIdRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderCloseAllByIdRequest)) {
      throw new TypeError('Instance of OrderCloseAllByIdRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrderCloseAllByIdRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      OrderIds: ((this.OrderIds != null) ? Array.from(this.OrderIds, item => ((item != null) ? item.toNumber() : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrderCloseAllByIdRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrderCloseAllByIdRequest} other Object value
   * @returns {!OrderCloseAllByIdRequest} Created struct
   */
  static fromObject (other) {
    return new OrderCloseAllByIdRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrderCloseAllByIdRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrderCloseAllByIdRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrderCloseAllByIdRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5101
  }
}

export { OrderCloseAllByIdRequest };

/**
 * Fast Binary Encoding OrderCloseAllByIdRequest field model
 */
class FieldModelOrderCloseAllByIdRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.OrderIds = new fbe.FieldModelVector(new fbe.FieldModelUInt64(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelOrderCloseAllByIdRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelOrderCloseAllByIdRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrderCloseAllByIdRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.OrderIds.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrderCloseAllByIdRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.OrderIds.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrderCloseAllByIdRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrderCloseAllByIdRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrderCloseAllByIdRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5101
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrderCloseAllByIdRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrderCloseAllByIdRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.OrderIds.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderIds.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderIds.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrderCloseAllByIdRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrderCloseAllByIdRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrderCloseAllByIdRequest}
   * @param {!OrderCloseAllByIdRequest} fbeValue Default value, defaults is new OrderCloseAllByIdRequest()
   * @returns {!OrderCloseAllByIdRequest} OrderCloseAllByIdRequest value
   */
  get (fbeValue = new OrderCloseAllByIdRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrderCloseAllByIdRequest}
   * @param {!OrderCloseAllByIdRequest} fbeValue OrderCloseAllByIdRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.OrderIds.fbeSize) <= fbeStructSize) {
      this.OrderIds.get(fbeValue.OrderIds)
    } else {
      fbeValue.OrderIds.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderIds.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrderCloseAllByIdRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrderCloseAllByIdRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrderCloseAllByIdRequest}
   * @param {!OrderCloseAllByIdRequest} fbeValue OrderCloseAllByIdRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrderCloseAllByIdRequest}
   * @param {OrderCloseAllByIdRequest} fbeValue OrderCloseAllByIdRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.OrderIds.set(fbeValue.OrderIds)
  }
}

export { FieldModelOrderCloseAllByIdRequest };

/**
 * Fast Binary Encoding OrderCloseAllByIdRequest model
 */
class OrderCloseAllByIdRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrderCloseAllByIdRequest(this.buffer, 4)
  }

  /**
   * Get the OrderCloseAllByIdRequest model
   * @this {!OrderCloseAllByIdRequestModel}
   * @returns {!FieldModelOrderCloseAllByIdRequest} model OrderCloseAllByIdRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrderCloseAllByIdRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrderCloseAllByIdRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrderCloseAllByIdRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrderCloseAllByIdRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrderCloseAllByIdRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrderCloseAllByIdRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrderCloseAllByIdRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrderCloseAllByIdRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrderCloseAllByIdRequestModel}
   * @param {!OrderCloseAllByIdRequest} value OrderCloseAllByIdRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrderCloseAllByIdRequestModel}
   * @param {!OrderCloseAllByIdRequest} value OrderCloseAllByIdRequest value, defaults is new OrderCloseAllByIdRequest()
   * @return {!object} Deserialized OrderCloseAllByIdRequest value and its size
   */
  deserialize (value = new OrderCloseAllByIdRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrderCloseAllByIdRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrderCloseAllByIdRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrderCloseAllByIdRequestModel}
   * @param {!number} prev Previous OrderCloseAllByIdRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrderCloseAllByIdRequestModel };
OrderCloseAllByIdRequest.__has_response = true;
OrderCloseAllByIdRequest.__response_class = OrderCloseAllResponse;
